module.exports = __webpack_public_path__ + "static/media/0010_LES_MURS_POSE_CHEVRON.6f3a5e8d.png";